var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("app-divider", { attrs: { label: "Ato legal da criação" } }),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 12 } },
            [
              _c("app-label", {
                attrs: { label: "Tipo de Documento Legal", required: true }
              }),
              _c(
                "el-select",
                {
                  staticClass: "full-width",
                  attrs: { placeholder: "Selecione o tipo de documento legal" },
                  model: {
                    value: _vm.informacoesAtosLegais.tipoDocumentoLegal,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.informacoesAtosLegais,
                        "tipoDocumentoLegal",
                        $$v
                      )
                    },
                    expression: "informacoesAtosLegais.tipoDocumentoLegal"
                  }
                },
                _vm._l(_vm.optionsTipoDocumentoLegal, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 12 } },
            [
              _c("app-label", {
                attrs: { label: "Instrumento da Publicação", required: true }
              }),
              _c(
                "el-radio-group",
                {
                  staticClass: "radio-group-horizontal",
                  model: {
                    value: _vm.informacoesAtosLegais.instrumentoPublicacao,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.informacoesAtosLegais,
                        "instrumentoPublicacao",
                        $$v
                      )
                    },
                    expression: "informacoesAtosLegais.instrumentoPublicacao"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "DiarioOficialUniao" } }, [
                    _vm._v("Diário Oficial da União")
                  ]),
                  _c("el-radio", { attrs: { label: "DiarioOficialEstado" } }, [
                    _vm._v("Diário Oficial do Estado")
                  ]),
                  _c(
                    "el-radio",
                    { attrs: { label: "DiarioOficialMunicipio" } },
                    [_vm._v("Diário Oficial do Município")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _vm.informacoesAtosLegais.instrumentoPublicacao ===
            "DiarioOficialEstado" ||
          _vm.informacoesAtosLegais.instrumentoPublicacao ===
            "DiarioOficialMunicipio"
            ? _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 4 } },
                [
                  _c("app-label", { attrs: { label: "UF", required: true } }),
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width-select",
                      attrs: { placeholder: "Selecione a UF" },
                      on: { change: _vm.changeEstado },
                      model: {
                        value: _vm.informacoesAtosLegais.uf,
                        callback: function($$v) {
                          _vm.$set(_vm.informacoesAtosLegais, "uf", $$v)
                        },
                        expression: "informacoesAtosLegais.uf"
                      }
                    },
                    _vm._l(_vm.estadosBr, function(estado) {
                      return _c("el-option", {
                        key: estado.codigo,
                        attrs: { label: estado.nome, value: estado.codigo }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.informacoesAtosLegais.municipio &&
          _vm.informacoesAtosLegais.municipio !== "" &&
          (_vm.informacoesAtosLegais.instrumentoPublicacao ===
            "DiarioOficialEstado" ||
            _vm.informacoesAtosLegais.instrumentoPublicacao ===
              "DiarioOficialMunicipio")
            ? _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 4 } },
                [
                  _c("app-label", {
                    attrs: { label: "Município", required: true }
                  }),
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width-select",
                      attrs: { placeholder: "Selecione o município" },
                      model: {
                        value: _vm.informacoesAtosLegais.municipio.id,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.informacoesAtosLegais.municipio,
                            "id",
                            $$v
                          )
                        },
                        expression: "informacoesAtosLegais.municipio.id"
                      }
                    },
                    _vm._l(_vm.municipios, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.nome, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Número do Documento", required: true }
              }),
              _c("el-input", {
                staticClass: "input",
                attrs: {
                  type: "text",
                  placeholder: "Digite o número do documento"
                },
                model: {
                  value: _vm.informacoesAtosLegais.numeroDocumento,
                  callback: function($$v) {
                    _vm.$set(_vm.informacoesAtosLegais, "numeroDocumento", $$v)
                  },
                  expression: "informacoesAtosLegais.numeroDocumento"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Data do Documento", required: true }
              }),
              _c("el-date-picker", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "##/##/#####",
                    expression: "'##/##/#####'"
                  }
                ],
                staticClass: "full-width-documento",
                attrs: {
                  type: "date",
                  placeholder: "Selecione a data do documento",
                  format: "dd/MM/yyyy"
                },
                model: {
                  value: _vm.informacoesAtosLegais.dataDocumento,
                  callback: function($$v) {
                    _vm.$set(_vm.informacoesAtosLegais, "dataDocumento", $$v)
                  },
                  expression: "informacoesAtosLegais.dataDocumento"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Data da Publicação", required: true }
              }),
              _c("el-date-picker", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "##/##/#####",
                    expression: "'##/##/#####'"
                  }
                ],
                staticClass: "full-width",
                attrs: {
                  type: "date",
                  placeholder: "Selecione a data da publicação",
                  format: "dd/MM/yyyy"
                },
                model: {
                  value: _vm.informacoesAtosLegais.dataPublicacao,
                  callback: function($$v) {
                    _vm.$set(_vm.informacoesAtosLegais, "dataPublicacao", $$v)
                  },
                  expression: "informacoesAtosLegais.dataPublicacao"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Área em Hectares", required: true }
              }),
              _c("el-input", {
                staticClass: "input",
                attrs: {
                  type: "text",
                  placeholder: "Digite a área em hectares"
                },
                model: {
                  value: _vm.informacoesAtosLegais.areaHectares,
                  callback: function($$v) {
                    _vm.$set(_vm.informacoesAtosLegais, "areaHectares", $$v)
                  },
                  expression: "informacoesAtosLegais.areaHectares"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Link para Ato Legal", required: true }
              }),
              _c("el-input", {
                staticClass: "input",
                attrs: {
                  type: "text",
                  placeholder: "Digite o link para o ato legal"
                },
                model: {
                  value: _vm.informacoesAtosLegais.linkAtoLegal,
                  callback: function($$v) {
                    _vm.$set(_vm.informacoesAtosLegais, "linkAtoLegal", $$v)
                  },
                  expression: "informacoesAtosLegais.linkAtoLegal"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "margin mb-20", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 24 } },
            [
              _c("app-label", {
                attrs: { label: "Anexo do Ato Legal", required: true }
              }),
              _c("app-upload-area", {
                attrs: {
                  id: "documento",
                  target: "publico/upload",
                  fileType: _vm.validExtensions,
                  onSuccess: _vm.onSuccessAnexoAtoLegal,
                  hasDownloadButton: false,
                  documento: _vm.informacoesAtosLegais.anexoAtoLegal
                },
                on: { removerDocumento: _vm.removerAnexoAtoLegal },
                model: {
                  value: _vm.informacoesAtosLegais.anexoAtoLegal,
                  callback: function($$v) {
                    _vm.$set(_vm.informacoesAtosLegais, "anexoAtoLegal", $$v)
                  },
                  expression: "informacoesAtosLegais.anexoAtoLegal"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "margin mb-20", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 12 } },
            [
              _c("app-label", {
                attrs: {
                  label: "Existe outro ato legal que altera ou complementa?",
                  required: true
                }
              }),
              _c(
                "el-radio-group",
                {
                  model: {
                    value:
                      _vm.informacoesAtosLegais.existeAtoLegalOuComplementar,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.informacoesAtosLegais,
                        "existeAtoLegalOuComplementar",
                        $$v
                      )
                    },
                    expression:
                      "informacoesAtosLegais.existeAtoLegalOuComplementar"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "sim" } }, [_vm._v("Sim")]),
                  _c("el-radio", { attrs: { label: "nao" } }, [_vm._v("Não")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-divider", { attrs: { label: "Plano de manejo" } }),
      _c(
        "el-row",
        { staticClass: "margin mb-20", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 12 } },
            [
              _c("app-label", {
                attrs: { label: "Há plano de manejo aprovado?", required: true }
              }),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.informacoesAtosLegais.planoManejoAprovado,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.informacoesAtosLegais,
                        "planoManejoAprovado",
                        $$v
                      )
                    },
                    expression: "informacoesAtosLegais.planoManejoAprovado"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "sim" } }, [_vm._v("Sim")]),
                  _c("el-radio", { attrs: { label: "nao" } }, [_vm._v("Não")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.informacoesAtosLegais.planoManejoAprovado === "sim"
        ? _c(
            "el-row",
            { staticClass: "margin mb-20", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: { label: "Tipo de Documento Legal", required: true }
                  }),
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width",
                      attrs: {
                        placeholder: "Selecione o tipo de documento legal"
                      },
                      model: {
                        value:
                          _vm.informacoesAtosLegais.planoManejoTipoDocumento,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.informacoesAtosLegais,
                            "planoManejoTipoDocumento",
                            $$v
                          )
                        },
                        expression:
                          "informacoesAtosLegais.planoManejoTipoDocumento"
                      }
                    },
                    _vm._l(_vm.optionsTipoDocumentoLegal, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: {
                      label: "Instrumento da Publicação",
                      required: true
                    }
                  }),
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.informacoesAtosLegais
                            .instrumentoPublicacaoPlanoManejo,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.informacoesAtosLegais,
                            "instrumentoPublicacaoPlanoManejo",
                            $$v
                          )
                        },
                        expression:
                          "informacoesAtosLegais.instrumentoPublicacaoPlanoManejo"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        { attrs: { label: "DiarioOficialUniao" } },
                        [_vm._v("Diário Oficial da União")]
                      ),
                      _c(
                        "el-radio",
                        { attrs: { label: "DiarioOficialEstado" } },
                        [_vm._v("Diário Oficial do Estado")]
                      ),
                      _c(
                        "el-radio",
                        { attrs: { label: "DiarioOficialMunicipio" } },
                        [_vm._v("Diário Oficial do Município")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.informacoesAtosLegais.planoManejoAprovado === "sim"
        ? _c(
            "el-row",
            { staticClass: "margin mb-20", attrs: { gutter: 20 } },
            [
              _vm.informacoesAtosLegais.instrumentoPublicacaoPlanoManejo ===
                "DiarioOficialEstado" ||
              _vm.informacoesAtosLegais.instrumentoPublicacaoPlanoManejo ===
                "DiarioOficialMunicipio"
                ? _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 4 } },
                    [
                      _c("app-label", {
                        attrs: { label: "UF", required: true }
                      }),
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width",
                          attrs: { placeholder: "Selecione a UF" },
                          on: { change: _vm.changeEstadoPlanoManejo },
                          model: {
                            value: _vm.informacoesAtosLegais.ufPlanoManejo,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.informacoesAtosLegais,
                                "ufPlanoManejo",
                                $$v
                              )
                            },
                            expression: "informacoesAtosLegais.ufPlanoManejo"
                          }
                        },
                        _vm._l(_vm.estadosBr, function(estado) {
                          return _c("el-option", {
                            key: estado.codigo,
                            attrs: { label: estado.nome, value: estado.codigo }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.informacoesAtosLegais.municipioPlanoManejo &&
              _vm.informacoesAtosLegais.municipioPlanoManejo !== "" &&
              (_vm.informacoesAtosLegais.instrumentoPublicacaoPlanoManejo ===
                "DiarioOficialEstado" ||
                _vm.informacoesAtosLegais.instrumentoPublicacaoPlanoManejo ===
                  "DiarioOficialMunicipio")
                ? _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 4 } },
                    [
                      _c("app-label", {
                        attrs: { label: "Município", required: true }
                      }),
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width-select",
                          attrs: { placeholder: "Selecione o município" },
                          model: {
                            value:
                              _vm.informacoesAtosLegais.municipioPlanoManejo.id,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.informacoesAtosLegais.municipioPlanoManejo,
                                "id",
                                $$v
                              )
                            },
                            expression:
                              "informacoesAtosLegais.municipioPlanoManejo.id"
                          }
                        },
                        _vm._l(_vm.municipiosPlanoManejo, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.nome, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("app-label", {
                    attrs: { label: "Número do Documento", required: true }
                  }),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: {
                      type: "text",
                      placeholder: "Digite o número do documento do plano"
                    },
                    model: {
                      value: _vm.informacoesAtosLegais.numeroDocumentoPlano,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "numeroDocumentoPlano",
                          $$v
                        )
                      },
                      expression: "informacoesAtosLegais.numeroDocumentoPlano"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("app-label", {
                    attrs: { label: "Data do Documento", required: true }
                  }),
                  _c("el-date-picker", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "##/##/#####",
                        expression: "'##/##/#####'"
                      }
                    ],
                    staticClass: "full-width-documento",
                    attrs: {
                      type: "date",
                      placeholder: "Selecione a data do documento do plano",
                      format: "dd/MM/yyyy"
                    },
                    model: {
                      value: _vm.informacoesAtosLegais.dataDocumentoPlano,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "dataDocumentoPlano",
                          $$v
                        )
                      },
                      expression: "informacoesAtosLegais.dataDocumentoPlano"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("app-label", {
                    attrs: { label: "Data da publicação", required: true }
                  }),
                  _c("el-date-picker", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "##/##/#####",
                        expression: "'##/##/#####'"
                      }
                    ],
                    staticClass: "full-width",
                    attrs: {
                      type: "date",
                      placeholder: "Selecione a data da publicação",
                      format: "dd/MM/yyyy"
                    },
                    model: {
                      value: _vm.informacoesAtosLegais.dataPublicacaoPlano,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "dataPublicacaoPlano",
                          $$v
                        )
                      },
                      expression: "informacoesAtosLegais.dataPublicacaoPlano"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("app-label", {
                    attrs: {
                      label: "Link para documento ato legal",
                      required: true
                    }
                  }),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: {
                      type: "text",
                      placeholder: "Digite o link para ato legal"
                    },
                    model: {
                      value: _vm.informacoesAtosLegais.linkPlanoManejoAtoLegal,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "linkPlanoManejoAtoLegal",
                          $$v
                        )
                      },
                      expression:
                        "informacoesAtosLegais.linkPlanoManejoAtoLegal"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("app-label", {
                    attrs: {
                      label: "Link para documento do Plano de Manejo",
                      required: true
                    }
                  }),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: {
                      type: "text",
                      placeholder: "Digite o link para o plano de manejo"
                    },
                    model: {
                      value: _vm.informacoesAtosLegais.linkPlanoManejo,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "linkPlanoManejo",
                          $$v
                        )
                      },
                      expression: "informacoesAtosLegais.linkPlanoManejo"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.informacoesAtosLegais.planoManejoAprovado === "sim"
        ? _c(
            "el-row",
            { staticClass: "margin mb-20", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 24 } },
                [
                  _c("app-label", { attrs: { label: "Anexo do ato legal" } }),
                  _c("app-upload-area", {
                    attrs: {
                      id: "documentoPlanoManejoAtoLegal",
                      target: "publico/upload",
                      fileType: _vm.validExtensions,
                      onSuccess: _vm.onSuccessAnexoPlanoManejoAtoLegal,
                      hasDownloadButton: false,
                      documento:
                        _vm.informacoesAtosLegais.anexoPlanoManejoAtoLegal
                    },
                    on: { removerDocumento: _vm.removerAnexoPlanoManejo },
                    model: {
                      value: _vm.informacoesAtosLegais.anexoPlanoManejoAtoLegal,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "anexoPlanoManejoAtoLegal",
                          $$v
                        )
                      },
                      expression:
                        "informacoesAtosLegais.anexoPlanoManejoAtoLegal"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.informacoesAtosLegais.planoManejoAprovado === "sim"
        ? _c(
            "el-row",
            { staticClass: "margin mb-20", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 24 } },
                [
                  _c("app-label", {
                    attrs: {
                      label: "Anexo pdf do documento plano manejo",
                      required: true
                    }
                  }),
                  _c("app-upload-area", {
                    attrs: {
                      id: "documentoPlanoManejo",
                      target: "publico/upload",
                      fileType: _vm.validExtensions,
                      onSuccess: _vm.onSuccessAnexoPlanoManejo,
                      hasDownloadButton: false,
                      documento: _vm.informacoesAtosLegais.anexoPlanoManejo
                    },
                    on: { removerDocumento: _vm.removerAnexoPlanoManejo },
                    model: {
                      value: _vm.informacoesAtosLegais.anexoPlanoManejo,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "anexoPlanoManejo",
                          $$v
                        )
                      },
                      expression: "informacoesAtosLegais.anexoPlanoManejo"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("app-divider", { attrs: { label: "Documento Conselho" } }),
      _c(
        "el-row",
        { staticClass: "margin mb-20", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 12 } },
            [
              _c("app-label", {
                attrs: {
                  label: "Deseja adicionar documento do conselho?",
                  required: true
                }
              }),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.informacoesAtosLegais.documentoConselho,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.informacoesAtosLegais,
                        "documentoConselho",
                        $$v
                      )
                    },
                    expression: "informacoesAtosLegais.documentoConselho"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "sim" } }, [_vm._v("Sim")]),
                  _c("el-radio", { attrs: { label: "nao" } }, [_vm._v("Não")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.informacoesAtosLegais.documentoConselho === "sim"
        ? _c(
            "el-row",
            { staticClass: "margin mb-20", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: { label: "Tipo de Documento Conselho" }
                  }),
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width",
                      attrs: {
                        placeholder: "Selecione o tipo de documento legal"
                      },
                      model: {
                        value:
                          _vm.informacoesAtosLegais.tipoDocumentoLegalConselho,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.informacoesAtosLegais,
                            "tipoDocumentoLegalConselho",
                            $$v
                          )
                        },
                        expression:
                          "informacoesAtosLegais.tipoDocumentoLegalConselho"
                      }
                    },
                    _vm._l(_vm.optionsTipoDocumentoLegal, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: {
                      label: "Instrumento da Publicação",
                      required: true
                    }
                  }),
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.informacoesAtosLegais
                            .instrumentoPublicacaoConselho,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.informacoesAtosLegais,
                            "instrumentoPublicacaoConselho",
                            $$v
                          )
                        },
                        expression:
                          "informacoesAtosLegais.instrumentoPublicacaoConselho"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        { attrs: { label: "DiarioOficialUniao" } },
                        [_vm._v("Diário Oficial da União")]
                      ),
                      _c(
                        "el-radio",
                        { attrs: { label: "DiarioOficialEstado" } },
                        [_vm._v("Diário Oficial do Estado")]
                      ),
                      _c(
                        "el-radio",
                        { attrs: { label: "DiarioOficialMunicipio" } },
                        [_vm._v("Diário Oficial do Município")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.informacoesAtosLegais.documentoConselho === "sim"
        ? _c(
            "el-row",
            { staticClass: "margin mb-20", attrs: { gutter: 20 } },
            [
              _vm.informacoesAtosLegais.instrumentoPublicacaoConselho ===
                "DiarioOficialEstado" ||
              _vm.informacoesAtosLegais.instrumentoPublicacaoConselho ===
                "DiarioOficialMunicipio"
                ? _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 6 } },
                    [
                      _c("app-label", {
                        attrs: { label: "UF", required: true }
                      }),
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width",
                          attrs: { placeholder: "Selecione a UF" },
                          on: { change: _vm.changeEstadoConselho },
                          model: {
                            value: _vm.informacoesAtosLegais.ufConselho,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.informacoesAtosLegais,
                                "ufConselho",
                                $$v
                              )
                            },
                            expression: "informacoesAtosLegais.ufConselho"
                          }
                        },
                        _vm._l(_vm.estadosBr, function(estado) {
                          return _c("el-option", {
                            key: estado.codigo,
                            attrs: { label: estado.nome, value: estado.codigo }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.informacoesAtosLegais.municipioConselho &&
              _vm.informacoesAtosLegais.municipioConselho !== "" &&
              (_vm.informacoesAtosLegais.instrumentoPublicacaoConselho ===
                "DiarioOficialEstado" ||
                _vm.informacoesAtosLegais.instrumentoPublicacaoConselho ===
                  "DiarioOficialMunicipio")
                ? _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 6 } },
                    [
                      _c("app-label", {
                        attrs: { label: "Município", required: true }
                      }),
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width-select",
                          attrs: { placeholder: "Selecione o município" },
                          model: {
                            value:
                              _vm.informacoesAtosLegais.municipioConselho.id,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.informacoesAtosLegais.municipioConselho,
                                "id",
                                $$v
                              )
                            },
                            expression:
                              "informacoesAtosLegais.municipioConselho.id"
                          }
                        },
                        _vm._l(_vm.municipiosConselho, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.nome, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 6 } },
                [
                  _c("app-label", {
                    attrs: { label: "Número do Documento", required: true }
                  }),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: {
                      type: "text",
                      placeholder: "Digite o número do documento do plano"
                    },
                    model: {
                      value: _vm.informacoesAtosLegais.numeroDocumentoConselho,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "numeroDocumentoConselho",
                          $$v
                        )
                      },
                      expression:
                        "informacoesAtosLegais.numeroDocumentoConselho"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 6 } },
                [
                  _c("app-label", {
                    attrs: { label: "Data do Documento", required: true }
                  }),
                  _c("el-date-picker", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "##/##/#####",
                        expression: "'##/##/#####'"
                      }
                    ],
                    staticClass: "full-width-documento",
                    attrs: {
                      type: "date",
                      placeholder: "Selecione a data do documento do plano",
                      format: "dd/MM/yyyy"
                    },
                    model: {
                      value: _vm.informacoesAtosLegais.dataDocumentoConselho,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "dataDocumentoConselho",
                          $$v
                        )
                      },
                      expression: "informacoesAtosLegais.dataDocumentoConselho"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c("app-label", { attrs: { label: "Data da publicação" } }),
                  _c("el-date-picker", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "##/##/#####",
                        expression: "'##/##/#####'"
                      }
                    ],
                    staticClass: "full-width",
                    attrs: {
                      type: "date",
                      placeholder: "Selecione a data da publicação",
                      format: "dd/MM/yyyy"
                    },
                    model: {
                      value: _vm.informacoesAtosLegais.dataPublicacaoConselho,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "dataPublicacaoConselho",
                          $$v
                        )
                      },
                      expression: "informacoesAtosLegais.dataPublicacaoConselho"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: { label: "Link para ato legal", required: true }
                  }),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: {
                      type: "text",
                      placeholder: "Digite o link para ato legal"
                    },
                    model: {
                      value: _vm.informacoesAtosLegais.linkPlanoManejoConselho,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "linkPlanoManejoConselho",
                          $$v
                        )
                      },
                      expression:
                        "informacoesAtosLegais.linkPlanoManejoConselho"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.informacoesAtosLegais.documentoConselho === "sim"
        ? _c(
            "el-row",
            { staticClass: "margin mb-20", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 24 } },
                [
                  _c("app-label", {
                    attrs: { label: "Anexo do ato legal", required: true }
                  }),
                  _c("app-upload-area", {
                    attrs: {
                      id: "documentoConselho",
                      target: "publico/upload",
                      fileType: _vm.validExtensions,
                      onSuccess: _vm.onSuccessAnexoDocumentoConselho,
                      hasDownloadButton: false,
                      documento:
                        _vm.informacoesAtosLegais.anexoDocumentoConselho
                    },
                    on: { removerDocumento: _vm.removerAnexoDocumentoConselho },
                    model: {
                      value: _vm.informacoesAtosLegais.anexoDocumentoConselho,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "anexoDocumentoConselho",
                          $$v
                        )
                      },
                      expression: "informacoesAtosLegais.anexoDocumentoConselho"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("app-divider", { attrs: { label: "Gestão/Planejamento" } }),
      _c(
        "el-row",
        { staticClass: "margin mb-20", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 12 } },
            [
              _c("app-label", {
                attrs: {
                  label:
                    "Deseja adicionar outros Instrumentos de Gestão/Planejamento?",
                  required: true
                }
              }),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.informacoesAtosLegais.outrosInstrumentos,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.informacoesAtosLegais,
                        "outrosInstrumentos",
                        $$v
                      )
                    },
                    expression: "informacoesAtosLegais.outrosInstrumentos"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "sim" } }, [_vm._v("Sim")]),
                  _c("el-radio", { attrs: { label: "nao" } }, [_vm._v("Não")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.informacoesAtosLegais.outrosInstrumentos === "sim"
        ? _c(
            "el-row",
            { staticClass: "margin mb-20", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: { label: "Tipo de Documento Legal", required: true }
                  }),
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width",
                      attrs: {
                        placeholder: "Selecione o tipo de documento legal"
                      },
                      model: {
                        value:
                          _vm.informacoesAtosLegais
                            .outrosInstrumentosTipoDocumento,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.informacoesAtosLegais,
                            "outrosInstrumentosTipoDocumento",
                            $$v
                          )
                        },
                        expression:
                          "informacoesAtosLegais.outrosInstrumentosTipoDocumento"
                      }
                    },
                    _vm._l(_vm.optionsTipoDocumentoLegal, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: {
                      label: "Instrumento da Publicação",
                      required: true
                    }
                  }),
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value:
                          _vm.informacoesAtosLegais.gestaoInstrumentoPublicacao,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.informacoesAtosLegais,
                            "gestaoInstrumentoPublicacao",
                            $$v
                          )
                        },
                        expression:
                          "informacoesAtosLegais.gestaoInstrumentoPublicacao"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        { attrs: { label: "DiarioOficialUniao" } },
                        [_vm._v("Diário Oficial da União")]
                      ),
                      _c(
                        "el-radio",
                        { attrs: { label: "DiarioOficialEstado" } },
                        [_vm._v("Diário Oficial do Estado")]
                      ),
                      _c(
                        "el-radio",
                        { attrs: { label: "DiarioOficialMunicipio" } },
                        [_vm._v("Diário Oficial do Município")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.informacoesAtosLegais.outrosInstrumentos === "sim"
        ? _c(
            "el-row",
            { staticClass: "margin mb-20", attrs: { gutter: 20 } },
            [
              _vm.informacoesAtosLegais.gestaoInstrumentoPublicacao ===
                "DiarioOficialEstado" ||
              _vm.informacoesAtosLegais.gestaoInstrumentoPublicacao ===
                "DiarioOficialMunicipio"
                ? _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 6 } },
                    [
                      _c("app-label", {
                        attrs: { label: "UF", required: true }
                      }),
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width",
                          attrs: { placeholder: "Selecione a UF" },
                          on: { change: _vm.changeEstadoGestao },
                          model: {
                            value: _vm.informacoesAtosLegais.ufGestao,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.informacoesAtosLegais,
                                "ufGestao",
                                $$v
                              )
                            },
                            expression: "informacoesAtosLegais.ufGestao"
                          }
                        },
                        _vm._l(_vm.estadosBr, function(estado) {
                          return _c("el-option", {
                            key: estado.codigo,
                            attrs: { label: estado.nome, value: estado.codigo }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.informacoesAtosLegais.municipioGestao &&
              _vm.informacoesAtosLegais.municipioGestao !== "" &&
              (_vm.informacoesAtosLegais.gestaoInstrumentoPublicacao ===
                "DiarioOficialEstado" ||
                _vm.informacoesAtosLegais.gestaoInstrumentoPublicacao ===
                  "DiarioOficialMunicipio")
                ? _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 6 } },
                    [
                      _c("app-label", {
                        attrs: { label: "Município", required: true }
                      }),
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width-select",
                          attrs: { placeholder: "Selecione o município" },
                          model: {
                            value: _vm.informacoesAtosLegais.municipioGestao.id,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.informacoesAtosLegais.municipioGestao,
                                "id",
                                $$v
                              )
                            },
                            expression:
                              "informacoesAtosLegais.municipioGestao.id"
                          }
                        },
                        _vm._l(_vm.municipiosGestao, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.nome, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 6 } },
                [
                  _c("app-label", {
                    attrs: { label: "Número do Documento", required: true }
                  }),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: {
                      type: "text",
                      placeholder: "Digite o número do documento"
                    },
                    model: {
                      value:
                        _vm.informacoesAtosLegais.numeroDocumentoPlanoGestao,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "numeroDocumentoPlanoGestao",
                          $$v
                        )
                      },
                      expression:
                        "informacoesAtosLegais.numeroDocumentoPlanoGestao"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 6 } },
                [
                  _c("app-label", {
                    attrs: { label: "Data do Documento", required: true }
                  }),
                  _c("el-date-picker", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "##/##/#####",
                        expression: "'##/##/#####'"
                      }
                    ],
                    staticClass: "full-width-documento",
                    attrs: {
                      type: "date",
                      placeholder: "Selecione a data do documento",
                      format: "dd/MM/yyyy"
                    },
                    model: {
                      value: _vm.informacoesAtosLegais.dataDocumentoPlanoGestao,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "dataDocumentoPlanoGestao",
                          $$v
                        )
                      },
                      expression:
                        "informacoesAtosLegais.dataDocumentoPlanoGestao"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: { label: "Data da Publicação", required: true }
                  }),
                  _c("el-date-picker", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "##/##/#####",
                        expression: "'##/##/#####'"
                      }
                    ],
                    staticClass: "full-width",
                    attrs: {
                      type: "date",
                      placeholder: "Selecione a data da publicação",
                      format: "dd/MM/yyyy"
                    },
                    model: {
                      value: _vm.informacoesAtosLegais.dataPublicacaoGestao,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "dataPublicacaoGestao",
                          $$v
                        )
                      },
                      expression: "informacoesAtosLegais.dataPublicacaoGestao"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: { label: "Link para ato legal", required: true }
                  }),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: {
                      type: "text",
                      placeholder: "Digite o link para ato legal"
                    },
                    model: {
                      value:
                        _vm.informacoesAtosLegais.linkPlanoManejoGestaoAtoLegal,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "linkPlanoManejoGestaoAtoLegal",
                          $$v
                        )
                      },
                      expression:
                        "informacoesAtosLegais.linkPlanoManejoGestaoAtoLegal"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.informacoesAtosLegais.outrosInstrumentos === "sim"
        ? _c(
            "el-row",
            { staticClass: "margin mb-20", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 24 } },
                [
                  _c("app-label", {
                    attrs: { label: "Anexo do ato legal", required: true }
                  }),
                  _c("app-upload-area", {
                    attrs: {
                      id: "documentoGestaoAtoLegal",
                      target: "publico/upload",
                      fileType: _vm.validExtensions,
                      onSuccess: _vm.onSuccessInstrumentosGestaoAtoLegal,
                      hasDownloadButton: false,
                      documento:
                        _vm.informacoesAtosLegais.anexoInstrumentoGestaoAtoLegal
                    },
                    on: {
                      removerDocumento: _vm.removerInstrumentoGestaoAtoLegal
                    },
                    model: {
                      value:
                        _vm.informacoesAtosLegais
                          .anexoInstrumentoGestaoAtoLegal,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "anexoInstrumentoGestaoAtoLegal",
                          $$v
                        )
                      },
                      expression:
                        "informacoesAtosLegais.anexoInstrumentoGestaoAtoLegal"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.informacoesAtosLegais.outrosInstrumentos === "sim"
        ? _c(
            "el-row",
            { staticClass: "margin mb-20", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: {
                      label: "Tipo de Instrumento de Gestão/Planejamento",
                      required: true
                    }
                  }),
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width",
                      attrs: {
                        placeholder: "Selecione o tipo de documento legal"
                      },
                      model: {
                        value:
                          _vm.informacoesAtosLegais.tipoDocumentoLegalGestao,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.informacoesAtosLegais,
                            "tipoDocumentoLegalGestao",
                            $$v
                          )
                        },
                        expression:
                          "informacoesAtosLegais.tipoDocumentoLegalGestao"
                      }
                    },
                    _vm._l(_vm.optionsTipoInstrumentoGestao, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: {
                      label: "Link para o instrumento de gestão/planejamento",
                      required: true
                    }
                  }),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: {
                      type: "text",
                      placeholder:
                        "Digite o link para o instrumento de gestão/planejamento"
                    },
                    model: {
                      value: _vm.informacoesAtosLegais.linkPlanoManejoGestao,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "linkPlanoManejoGestao",
                          $$v
                        )
                      },
                      expression: "informacoesAtosLegais.linkPlanoManejoGestao"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.informacoesAtosLegais.outrosInstrumentos === "sim"
        ? _c(
            "el-row",
            { staticClass: "margin mb-20", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 24 } },
                [
                  _c("app-label", {
                    attrs: {
                      label: "Anexo do instrumento de gestão/planejamento",
                      required: true
                    }
                  }),
                  _c("app-upload-area", {
                    attrs: {
                      id: "documentoGestao",
                      target: "publico/upload",
                      fileType: _vm.validExtensions,
                      onSuccess: _vm.onSuccessInstrumentosGestao,
                      hasDownloadButton: false,
                      documento:
                        _vm.informacoesAtosLegais.anexoInstrumentoGestao
                    },
                    on: { removerDocumento: _vm.removerInstrumentoGestao },
                    model: {
                      value: _vm.informacoesAtosLegais.anexoInstrumentoGestao,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.informacoesAtosLegais,
                          "anexoInstrumentoGestao",
                          $$v
                        )
                      },
                      expression: "informacoesAtosLegais.anexoInstrumentoGestao"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77ae1d8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77ae1d8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppFormularioAtosLegais.vue
// module id = null
// module chunks = 